// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3qzxv","content":"RecentSearches_content__2EVMe"};